var __rspack_ns_object = JSON.parse('{"Copied":"Copiado","Failed to copy":"Falha ao copiar"}')